// extracted by mini-css-extract-plugin
module.exports = {"button":"reset-password-success_button__1V51Z"};